import { toastOptions } from '@/main'
import Clipboard from 'clipboard'
let showToastFlag = false

function showToast(message, variant) {
  this.$bvToast.toast(message, {
    variant: variant,
    ...toastOptions
  })
}

function showModal(type) {
  const target = this.$refs[type]
  if (target) {
    target.show()
  }
}

function hideModal(type) {
  const target = this.$refs[type]
  if (target) {
    target.hide()
  }
}

function focusInput(id) {
  this.$nextTick(() => {
    const target = document.getElementById(`input-${id}`)
    if (target) {
      target.focus()
    }
  })
}

function copyInput(id) {
  const target = document.querySelector(id)
  if (target) {
    target.select()
    document.execCommand('copy')
    target.blur()
    this.showToast('Copied to clipboard!', 'info')
  }
}

function scrollToBottom(classname) {
  const element = document.querySelector(classname)
  if (element) {
    element.scrollTo({ top: 0, behavior: 'smooth' })
  } else {
    window.scrollTo(0, document.body.scrollHeight)
  }
}

function showDeletePopover(id) {
  this.$root.$emit('bv::hide::popover')
  this.$root.$emit('bv::show::popover', `deleteButton-${id}`)
}

function hideDeletePopover(id) {
  this.$root.$emit('bv::hide::popover', `deleteButton-${id}`)
}

function onHideAttempt(event) {
  const button = document.getElementById('cancelModal')
  if (event.trigger == 'backdrop') {
    event.preventDefault()
    button.classList.add('btn-shake')
    setTimeout(() => { button.classList.remove('btn-shake') }, 500)
  }
}

function filterKey(event) {
  const key = event.key
  if (key === '.' || key === 'e') {
    event.preventDefault()
  }
}

function initClipboard(id) {
  this.clipboard = new Clipboard(`#${id}`)

  const showToast = (message, type) => {
    if (!showToastFlag) {
      this.showToast(message, type)
      showToastFlag = true
      setTimeout(() => showToastFlag = false, 100)
    }
  }

  this.clipboard.on('success', () => {
    showToast('Copied to clipboard!', 'info')
  })
  this.clipboard.on('error', () => {
    showToast('Failed to copy to clipboard!', 'danger')
  })
}

function destroyClipboard() {
  if (this.clipboard) {
    this.clipboard.on('success', false)
    this.clipboard.on('error', false)
    this.clipboard.destroy()
    this.clipboard = null
  }
}

function restoreTableColumns(id) {
  const savedData = localStorage.getItem(id)
  if (!savedData) { return }
  const parsedData = JSON.parse(savedData)
  this.fields = parsedData
}

function generateUniqueId(min = 1000000, max = 10000000) {
  const minVal = Math.ceil(min)
  const maxVal = Math.floor(max)
  return Math.floor(Math.random() * (maxVal - minVal + 1)) + minVal
}

function groupByCountry(data) {
  const groupedData = {}
  data.forEach(obj => {
    const { country, ...rest } = obj
    const { code, name } = country
    if (!groupedData[code]) {
      groupedData[code] = { country_code: code, country_name: name, servers: [] }
    }
    groupedData[code].servers.push({ country, ...rest })
  })
  return Object.values(groupedData)
}

export {
  showToast,
  showModal,
  hideModal,
  focusInput,
  copyInput,
  scrollToBottom,
  showDeletePopover,
  hideDeletePopover,
  onHideAttempt,
  filterKey,
  initClipboard,
  destroyClipboard,
  restoreTableColumns,
  generateUniqueId,
  groupByCountry,
}
